// extracted by mini-css-extract-plugin
export default {"container":"grid_container__3ph2g","article":"grid_article__2uQri"};